export default __webpack_public_path__ + "static/media/Tesla Corporation.2a9fd398.png";